export const SET_PATIENT_LIST_DATA = "set-patient-list-data";

